// extracted by mini-css-extract-plugin
export default {"imagecontainer":"ImageTab_imagecontainer__Hw-k3","upload":"ImageTab_upload__TJwGD"};